import { Button } from '@/components/ui/button';
import useOpenApiClient from '@/hooks/useOpenApiClient';
import { useMutation, useQuery } from '@tanstack/react-query';

export default function APITestProof() {
  const { apiFetch } = useOpenApiClient();

  const receiptsQuery2 = useQuery({
    queryKey: ['openapi-demo', 'receipts'],
    queryFn: () => apiFetch?.GET('/receipts'),
  });

  const pingQuery2 = useQuery({
    queryKey: ['openapi-demo', 'ping'],
    queryFn: () => apiFetch?.GET('/debug/ping'),
  });

  const adminPing2 = useQuery({
    queryKey: ['openapi-demo', 'admin-ping'],
    queryFn: () => apiFetch?.GET('/admin/ping'),
  });

  const meQuery2 = useQuery({
    queryKey: ['openapi-demo', 'me'],
    queryFn: () => apiFetch?.GET('/debug/me') || null,
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Results = ({ title, q }: { title: string; q: any }) => {
    return (
      <div className="overflow-scroll text-xs">
        <h3 className="text-lg font-bold">{title}</h3>
        {q.isLoading && <p>Loading...</p>}
        {q.isError && <pre>{JSON.stringify(q.error, null, 2)}</pre>}
        {q.isSuccess && <pre>{JSON.stringify(q.data, null, 2)}</pre>}
      </div>
    );
  };

  const { mutate } = useMutation({
    mutationFn: async (code: number | undefined) => {
      if (code === undefined) {
        console.log('throw');
        throw new Error('Code must be defined');
      }
      const response = await apiFetch.GET(`/debug/error/{code}`, {
        params: {
          path: {
            code,
          },
        },
      });
      return response;
    },
  });

  return (
    <div className="space-y-4">
      <h1 className="mb-6 text-2xl font-bold">API Test</h1>
      <p className="text-gray-600">
        This page is for testing API calls. It will be removed when we have some actual APIs to
        integrate.
      </p>

      <p>Here are some ways to trigger API errors</p>
      <div>
        {[undefined, 400, 401, 403, 404, 422, 500, 501].map((code) => (
          <Button size="sm" onClick={() => mutate(code)} key={code || 'undefined'}>
            {code || 'Trigger Error'}
          </Button>
        ))}
      </div>

      <p>Here we are showing how to do API calls using OpenAPI Fetch via Tanstack Query.</p>

      <div>
        <Results title="Receipts" q={receiptsQuery2} />
        <Results title="Ping" q={pingQuery2} />
        <Results title="Admin Ping" q={adminPing2} />
        <Results title="Me" q={meQuery2} />
      </div>
    </div>
  );
}
